import { jsx as _jsx } from "react/jsx-runtime";
import MuiButton from '@material-ui/core/Button';
import capitalize from 'lodash/capitalize';
/**
 * Wrapping component for Material UI Button.
 * Provides additional color variants (`error`, `info`, `warning`, `success`)
 */
export function AgentNetButton({ children, color, ...props }) {
    const className = `${props.variant}${capitalize(color)}`;
    const colorProp = ['default', 'inherit', 'primary', 'secondary'].indexOf(color) > -1
        ? color
        : undefined;
    return (_jsx(MuiButton, { ...props, color: colorProp, className: className, children: children }));
}
